import { COMMON_TAGS, UNKNOWN_TAG } from '@atlassian/search-common/constants';
import { getSentryClient } from '@atlassian/search-common/sentry';

import { type PrimaryProductKey } from '../../common/constants/products';

export type onError = (error: any) => Promise<void>;

export const logException = async (
	error: any,
	userId?: string | null,
	primaryProduct?: PrimaryProductKey,
): Promise<void> => {
	try {
		const SentryClient = await getSentryClient();

		if (!SentryClient) {
			return;
		}

		SentryClient.withScope((scope) => {
			for (const [key, value] of Object.entries(COMMON_TAGS)) {
				scope.setTag(key, value);
			}
			scope.setUser({ id: userId || UNKNOWN_TAG });
			scope.setTag('product', primaryProduct || UNKNOWN_TAG);
			SentryClient.captureException(error, scope);
		});
	} catch (error) {
		// When there was an error with Sentry, just output to console
		// eslint-disable-next-line no-console
		console.error(error);
	}
};
